import React from 'react';

import PanelHome from '../panels/PanelHome';
import PanelPhotos from '../panels/PanelPhotos';
import PanelLetter from '../panels/PanelLetter';
import PanelMemories from '../panels/PanelMemories';
import PanelSchool from '../panels/PanelSchool';
import { PanelCover, PanelChild, PanelOrder } from '../panels/SettingsPanels';
import MediaGallery from '../panels/MediaGallery';
import PanelCartoon from '../components/PanelCartoon';

/**
 * Maps route keys to panel components.
 * Keeps panel wiring out of the app shell.
 */
export default function PanelRenderer({ activeNav, state, onNavigate, onUpgrade }) {
  const order_item_id = state.orderSummary?.order_item_id;
      // const order_item_id = "4942e3c3-c767-4b23-ac74-9f3648a518cf"
  switch (activeNav) {
    case 'home':
      return (
        <PanelHome
          child={state.activeChild}
          isPro={state.isPro}
          limits={state.limits}
          onNavigate={onNavigate}
          progress={state.progress}
          bookConfig={state.bookConfig}
          sections={state?.sections?.length ? state.sections : state?.bookConfig?.sections || []}
        />
      );
    case 'photos':
      return (
        <PanelPhotos
          projectId={state.activeChild?.project_id}
          backendPhotos={state.backendPhotos}
          displayPhotos={state.displayPhotos}
          onAdd={state.addPhotos}
          onRemove={state.removePhoto}
          onRemoveUpload={state.removeUploadItem}
          limit={state.limits.photos}
          isPro={state.isPro}
          onUpgrade={onUpgrade}
          bookConfig={state.bookConfig}
          progress={state.progress}
          childName={state.activeChild?.first_name || state.activeChild?.name || 'your child'}
        />
      );
    case 'personal_notes':
      return (
        <PanelLetter
          letters={state.letterNotes}
          text={state.letterText}
          onAddLetter={state.addLetter}
          onUpdateLetter={state.updateLetter}
          onDeleteLetter={state.deleteLetter}
          onSave={state.saveLetter}
          limit={state.limits.personalNoteChars}
          letterCountLimit={state.limits.personalNotes}
          isPro={state.isPro}
          onUpgrade={onUpgrade}
          bookConfig={state.bookConfig}
          childName={state.activeChild?.first_name || state.activeChild?.name || 'your child'}
        />
      );
    case 'memories':
      return (
        <PanelMemories
          memories={state.memories}
          onUpdateMemory={state.updateMemory}
          onAddCustom={state.addCustomMemory}
          onDeleteMemory={state.removeMemory}
          limit={state.limits.memories}
          filled={state.progress.memories}
          isPro={state.isPro}
          onUpgrade={onUpgrade}
          bookConfig={state.bookConfig}
          childName={state.activeChild?.first_name || state.activeChild?.name || 'your child'}
        />
      );
    // case 'school_photos':
    //   return (
    //     <PanelSchool
    //       schoolPhotos={state.schoolPhotos}
    //       onToggle={state.toggleSchoolPhoto}
    //       limit={state.limits.schoolPhotos}
    //       isPro={state.isPro}
    //       onUpgrade={onUpgrade}
    //       bookConfig={state.bookConfig}
    //     />
    //   );
    case 'school_photos':
      return (
          <MediaGallery
            orderId={order_item_id}
            projectId={state.activeChild?.project_id}
            limit={state.limits?.schoolPhotos ?? 0}
            onUpgrade={onUpgrade}
            bookConfig={state.bookConfig}
            onCapacityChange={state.refreshProjectData}
            childName={
              state.activeChild?.first_name ||
              state.activeChild?.name ||
              'your child'
            }
          />
      );
    case 'cover':
      return <PanelCover child={state.activeChild} onSave={state.updateCover} order_item_id={order_item_id} bookConfig={state.bookConfig} />;
    case 'cartoon':
      return <PanelCartoon child={state.activeChild} onSave={state.updateCover} bookConfig={state.bookConfig} userId={state.currentUser.user_id} projectId={state.activeChild?.project_id} />;
    case 'child':
      return <PanelChild child={state.activeChild} onSave={state.updateChild} bookConfig={state.bookConfig} />;
    case 'order':
      return (
        <PanelOrder
          projectId={state.activeChild?.project_id}
          initialOrder={state.orderSummary}
          offer={state.offer}
          onRefresh={state.refreshProjectData}
        />
      );
    default:
      return null;
  }
}
